import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import { path, equals, keys, omit } from 'ramda';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import FormTypes from '../../common/FormTypes';
import DialogPanel from '../../componets/DialogPanel.jsx';
import * as validator from '../../constant/Validator/CurrencyRate';
import * as CurrencyActions from '../../actions/Actions_CurrencyManager';

import CurrencyRate from '../../constant/JSON/CurrencyRate';
import ButtonText from '../../constant/Button/ButtonText';
import Button from '../../constant/Button';
import * as format  from '../../common/setFormat'
import { Colors, Family } from '../../themes';


import validate from "validate.js";
import { InitWaitingTime, SetStateWithTime, SetStateWithObject } from '../../common/SetTime.js';

let waitingTime = true;

const _style = { textAlign: 'start', width: '100%', paddingTop: 5 };
const _rowContainer = { display: 'flex' };
const RequireForm = <span style={{ color: Colors.error }}>* </span>;

let CurrencyList = [];

class CurrencyRateCard extends Component {
    state = { isLoading: false, msgError: undefined, dialogType: undefined, isBtnActive: false }

    constructor(props) {
        let error = null;
        super(props);
        this.state = {
            CurrencyInfo: this.props.CurrencyInfo,
            oldCurrencyInfo: this.props.oldCurrencyInfo,
            isUpdate: false,
        }
        this.props.getAPICurrencyList({ num_limit: 10 });

    }
    componentWillReceiveProps = (nextProps) => {
        const { CurrencyManager } = nextProps;

        if (!!CurrencyManager) {
            const { actions, data } = CurrencyManager.CURRENCY_REDUCER;

            switch (actions) {
                case CurrencyActions.GET_CURRENCY_SUCCESS:
                    {
                        CurrencyList = data.result;
                        SetStateWithTime(this, waitingTime);
                    } break;
                case CurrencyActions.GET_CURRENCY_FAILURE:
                    {
                        SetStateWithTime(this, waitingTime);
                    } break;
                case CurrencyActions.CREATE_CURRENCY_RATE_SUCCESS:
                    {
                        SetStateWithObject(this, waitingTime, { msgError: 'Create Currency Rate Success.', dialogType: 'success', });
                        this.setState({ currencyRateId: data.currencyRateId, isUpdate: true })
                        this.props.getAPICurrencyRateList({ num_limit: 10 });
                    } break;

                case CurrencyActions.UPDATE_CURRENCY_RATE_SUCCESS:
                    {
                        SetStateWithObject(this, waitingTime, { msgError: 'Update Currency Rate Success.', dialogType: 'success', });
                        this.setState({ isUpdate: false })
                        this.props.getAPICurrencyRateList({ num_limit: 10 });
                    } break;

                case CurrencyActions.CREATE_CURRENCY_RATE_FAILURE:
                case CurrencyActions.UPDATE_CURRENCY_RATE_FAILURE:
                    {
                        const _msg = data.response.data.error.message || actions;
                        SetStateWithObject(this, waitingTime, { msgError: _msg, dialogType: 'error', });
                    } break;
            }
        }
    }
    render() {
        const { classes, onClosePanel, isView, isEdit, CurrencyRateList } = this.props;
        const { isLoading, msgError, dialogType, isBtnActive } = this.state;
        const { onSave } = this;
        return (
            <div style={{ maxWidth: 800, textAlign: 'start', overflow: 'unset' }}>
                {(isLoading) && <DialogPanel Active={isLoading} MSG={msgError} Type={dialogType} OnClose={() => this.onCloseDialog()} />}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '10px' }}>
                    <Typography className={classes.title}>{isView ? null : isEdit ? CurrencyRate.HeaderPage.UPDATE_EN : CurrencyRate.HeaderPage.EN}</Typography>
                    {/* <Language LanguagePage={LanguageCurrency} onChangeState={this.props.onChangeLanguage} isValue={true} /> */}
                </div>

                {
                    CurrencyRate.BodyPage.map((row, index) => {
                        return (
                            <div key={index} style={_rowContainer}>
                                {row.map((each, index) => (<div key={index} style={_style}>{this.SetItemsWithType(each)}</div>))}
                            </div>
                        )
                    })
                }
                {!isView ?
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                        <Button.Themes
                            TitleText={ButtonText.BUTTON_CANCEL} style={{ paddingRight: '15px', }}
                            onClick={() => onClosePanel()} />
                        <Button.Themes
                            TitleText={ButtonText.BUTTON_SAVE} disabled={!isBtnActive}
                            onClick={() => onSave()} />
                    </div> : null}
            </div >
        )
    }

    SetItemsWithType(each) {

        const { classes, isView } = this.props;
        const { CurrencyInfo } = this.state;
        const { onChangeState } = this;
        let currency = path(['datas'], CurrencyList)
        switch (each.type) {
            case 'text': {
                let formatType = (each.format === 'price') ? format.PriceFormat : null
                return (
                    <FormTypes.TextFormat
                        InputFormat={formatType}
                        disabled={isView ? true : false}
                        error={!!path([each.stateName], this.error)}
                        Require={isView ? false : each.isRequired}
                        TitleText={each.title_EN}
                        value={path([each.stateName], CurrencyInfo)}
                        onChange={(e) => { onChangeState({ [each.stateName]: e.target.value }) }} />
                )
            }
            case 'select': {
                return (
                    <FormTypes.Select
                        disabled={isView ? true : false}
                        error={!!path([each.stateName], this.error)}
                        Require={each.isRequired}
                        TitleText={each.title_EN}
                        value={path([each.stateName], CurrencyInfo)}
                        onChange={(e) => { this.onChangeState({ [each.stateName]: e.target.value }) }}
                        options={Array.isArray(currency) && currency.map((option, i) => { return (<option key={option.currencyType} value={option.currencyType}> {option.currencyType} </option>) })} />

                )
            }
            case 'switch': {
                return (
                    <FormTypes.Switches Left
                        disabled={isView ? true : false}
                        ValueText={each.title_EN}
                        checked={path([each.stateName], CurrencyInfo) || false}
                        onChange={(e) => { onChangeState({ [each.stateName]: e.target.checked }) }} />
                )
            }
        }
    }
    onChangeState = (state) => {
        console.log('state', state);
        let CurrencyInfo = { ...this.state.CurrencyInfo };
        const { oldCurrencyInfo } = this.state;

        CurrencyInfo = { ...CurrencyInfo, ...state }

        console.log('new CurrencyInfo', CurrencyInfo)

        this.setState({ CurrencyInfo, isBtnActive: !equals(oldCurrencyInfo, CurrencyInfo) }, () => { this.validate(state); });
    }

    validate = (value) => {
        const fieldName = keys(value)[0];
        let result = true;
        if (!!validator.constraints[fieldName]) {
            const validateResult = validate(value, { [fieldName]: validator.constraints[fieldName] });
            const error = this.error || {};

            if (!!validateResult) {
                result = false;
                this.error = { ...error, ...validateResult };
                this.forceUpdate();
            } else {
                this.error = omit([fieldName], error);
                this.forceUpdate();
            }
        }
        return result;
    }

    validateAll() {
        let success = true;
        validator.input.forEach(each => {
            const validateResult = this.validate({
                [each.fieldName]: this.state.CurrencyInfo[each.fieldName],
            });;
            success = success && validateResult;
        });
        return success;
    }

    onSave = () => {

        const { isEdit } = this.props;
        const { isUpdate, currencyRateId } = this.state;
        let CurrencyInfo = { ...this.state.CurrencyInfo };

        if (this.validateAll()) {

            this.setState({ isLoading: true, isBtnActive: false });

            if (isEdit) {
                this.props.getAPIUpdateCurrencyRate(CurrencyInfo);
            }
            else if (isUpdate) {
                CurrencyInfo = { ...CurrencyInfo, currencyRateId: currencyRateId };
                this.props.getAPIUpdateCurrencyRate(CurrencyInfo);
            }
            else {
                this.props.getAPICreateCurrencyRate(CurrencyInfo);
            }
        }
        else {
            this.setState({ isLoading: true, msgError: 'Please complete the form.', dialogType: 'error', isBtnActive: false }, () => this.error)
        }
    }

    onCloseDialog = () => (this.setState({ isLoading: false, msgError: undefined, dialogType: undefined, }));

}

const styles = theme => ({
    title: { fontSize: '24px', display: 'flex' },
    textField: { width: '100%' },
      });
function mapStateToProps(state, ownProps) {
    return { ...state };
}
function mapDispatchToProps(dispatch) {
    return {
        getAPICurrencyRateList: (_keyword, _filter) => {
            InitWaitingTime();
            dispatch(CurrencyActions.getCurrencyRateList(_keyword, _filter));
        },
        getAPICreateCurrencyRate: (_confirmInfo) => {
            dispatch(CurrencyActions.APICreateCurrencyRate(_confirmInfo));
        },
        getAPIUpdateCurrencyRate: (_confirmInfo) => {
            dispatch(CurrencyActions.APIUpdateCurrencyRate(_confirmInfo));
        },
        getAPICurrencyList: (_keyword, _filter) => {
            InitWaitingTime();
            dispatch(CurrencyActions.getCurrencyList(_keyword, _filter));
        },
    }
}
CurrencyRateCard.propTypes = { classes: PropTypes.object.isRequired };

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CurrencyRateCard));